import { useAppContext } from "../../../../_context";
import Col from "react-bootstrap/Col";
import SignupField from "../../SignupField";
import { capitalize } from "@material-ui/core";
import FieldError from "../../../FieldError";
import FormBlock from "../../FormBlock";
import { Clear } from "@material-ui/icons";
import { query } from "../../../../utilities/Helpers";
import { useState } from "react";
import { availableSportNames } from "../../../../utilities/Constants";

const CourtRow = ({ court, hasClose, errors, usedSports, dispatcher }) => {
  const [{ tx }] = useAppContext();
  const idFrag = court.index;
  const [showSurfaceOther, setShowSurfaceOther] = useState(false);
  const onChange = () => {
    const item = {
      ...court,
      sport: query(`#signup-court-type-${idFrag}`).value,
      numberOfCourts: query(`#signup-n-courts-${idFrag}`).value || 0,
      location: query(`#signup-court-location-${idFrag}`).value,
      surface: JSON.parse(query(`#signup-surface-${idFrag}`).value || "[]"),
      surfaceOther:
        query(`#signup-surface-other-${idFrag}`)?.value.trim() || null,
      lights: query(`#signup-has-lighting-${idFrag}`).value,
    };

    setShowSurfaceOther(item.surface?.includes("other"));

    dispatcher({ type: "set-item", item });
  };
  const availableSports = availableSportNames
    .map((sport) => ({ value: sport, label: capitalize(tx[sport]) }))
    .filter((item) => !usedSports.includes(item.value));

  return (
    <FormBlock label={tx["About the courts"]}>
      {hasClose ? (
        <span style={{ color: "black" }}>
          <Clear
            onClick={() => dispatcher({ type: "remove-court", index: idFrag })}
            className="remove-court-icon"
          />
        </span>
      ) : null}
      <Col md={6}>
        <SignupField
          id={`court-type-${idFrag}`}
          label={tx["Select sport"]}
          mandatory={true}
          type="select"
          options={availableSports}
          onChange={onChange}
        />
        <FieldError
          fieldName={`signup-court-type-${idFrag}`}
          allErrors={errors}
        />
      </Col>

      <Col md={6}>
        <SignupField
          id={`n-courts-${idFrag}`}
          label={tx["Number of courts"]}
          type="number"
          min={0}
          defaultValue={court.numberOfCourts}
          onChange={onChange}
        />
      </Col>

      <Col md={6}>
        <SignupField
          id={`court-location-${idFrag}`}
          label={tx["Indoor/Outdoor"]}
          type="select"
          options={[
            { value: "indoor", label: tx["Indoor"] },
            { value: "outdoor", label: tx["Outdoor"] },
            { value: "both", label: tx["Both"] },
          ]}
          defaultValue={court.location}
          onChange={onChange}
        />
        <FieldError
          fieldName={`signup-court-location-${idFrag}`}
          allErrors={errors}
        />
      </Col>

      <Col md={6}>
        <SignupField
          id={`has-lighting-${idFrag}`}
          label={tx["Floodlights"]}
          type="select"
          options={[
            { value: "yes", label: tx["Yes"] },
            { value: "no", label: tx["No"] },
          ]}
          onChange={onChange}
        />
        <FieldError
          fieldName={`signup-has-lighting-${idFrag}`}
          allErrors={errors}
        />
      </Col>

      <Col xs={12}>
        <SignupField
          id={`surface-${idFrag}`}
          label={tx["Surface(s)"]}
          multiple
          type="select"
          options={[
            { value: "grass", label: tx["Grass"] },
            { value: "mixedSurfaces", label: tx["Mixed surfaces"] },
            { value: "syntheticGrass", label: tx["Synthetic grass"] },
            { value: "hard", label: tx["Hard"] },
            { value: "clay", label: tx["Clay"] },
            { value: "wood", label: tx["Wood"] },
            { value: "carpet", label: tx["Carpet"] },
            { value: "concrete", label: tx["Concrete"] },
            { value: "other", label: tx["Other (enter below)"] },
          ]}
          defaultValue={court.surface}
          onChange={onChange}
        />
        <FieldError fieldName={`signup-surface-${idFrag}`} allErrors={errors} />
      </Col>

      {showSurfaceOther ? (
        <Col xs={12}>
          <SignupField
            id={`surface-other-${idFrag}`}
            label={tx["Other surface"]}
            mandatory={true}
            onChange={onChange}
          />
          <FieldError
            fieldName={`signup-surface-other-${idFrag}`}
            allErrors={errors}
          />
        </Col>
      ) : null}
    </FormBlock>
  );
};

export default CourtRow;
